export default "__VITE_ASSET__DTo5CAyg__"